import type { PhotoModel } from '@sosocio/creator-types/project';

/**
 * Determine whether a failed-photo collection contains work that can be
 * submitted again. Errors without an explicit policy remain retryable for
 * backward compatibility with transient failures.
 *
 * @param photoModels Failed {@link PhotoModel} instances currently shown to the user.
 * @returns Whether at least one failed model can be retried.
 */
export function hasRetryablePhotoErrors(photoModels: readonly PhotoModel[]): boolean {
	return photoModels.some(isPhotoProcessingErrorRetryable);
}

/**
 * Apply the process-photo retry contract to a failed local model. Only an
 * explicit `retryable: false` represents a permanent failure.
 *
 * @param photoModel Failed {@link PhotoModel} being considered for retry.
 * @returns Whether Creator may submit the same source again.
 */
export function isPhotoProcessingErrorRetryable(photoModel: PhotoModel): boolean {
	return photoModel._error?.retryable !== false;
}
